import { render, staticRenderFns } from "./DamagedList.vue?vue&type=template&id=40bd43c1&scoped=true"
import script from "./DamagedList.vue?vue&type=script&lang=js"
export * from "./DamagedList.vue?vue&type=script&lang=js"
import style0 from "./DamagedList.vue?vue&type=style&index=0&id=40bd43c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd43c1",
  null
  
)

export default component.exports